import { observer } from 'mobx-react';
import { ChangeEvent, FC, useEffect, useMemo, useState } from 'react';

import { debounce } from '@servicetitan/design-system';
import { SearchField } from '@servicetitan/anvil2';

import { DEBOUNCE_DELAY } from '../../utils/ux';

import * as Styles from './debounced-search.module.less';

interface DebouncedSearchProps {
    externalValue?: string;
    onChange: (value: string) => void;
    placeholder?: string;
}

export const DebouncedSearch: FC<DebouncedSearchProps> = observer(
    ({ externalValue, onChange, placeholder = 'Search by Name or ID' }) => {
        const [value, setValue] = useState('');

        const handleDebouncedSearch = useMemo(
            () =>
                debounce((value: string) => {
                    onChange(value);
                }, DEBOUNCE_DELAY),
            [onChange],
        );

        const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
            const { value } = e.target;

            setValue(value);
            handleDebouncedSearch(value);
        };

        useEffect(() => {
            setValue(externalValue ?? '');
        }, [externalValue]);

        return (
            <SearchField
                size="small"
                value={value}
                onChange={handleSearch}
                placeholder={placeholder}
                className={Styles.input}
            />
        );
    },
);
